
export default {
    name: 'Index',
}
